import { Link } from "react-router-dom";
import { useCookies } from "../hooks/useCookies.js";
import CookieSettings from "./CookieSettings.jsx";

export default function CookieBanner() {
  const {
    consent,
    showBanner,
    showSettings,
    acceptAll,
    rejectAll,
    saveCustom,
    openSettings,
    closeSettings,
  } = useCookies();

  if (!showBanner && !showSettings) return null;

  return (
    <>
      {showBanner && !showSettings && (
        <div className="wc-cookie-banner" role="dialog" aria-label="Consentimiento de cookies">
          <div className="wc-cookie-inner">
            <div className="wc-cookie-brand">
              <div className="wc-cookie-logo" aria-hidden="true">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="14" cy="14" r="13" stroke="currentColor" strokeWidth="2" />
                  <circle cx="10" cy="11" r="2" fill="currentColor" />
                  <circle cx="18" cy="11" r="2" fill="currentColor" />
                  <circle cx="14" cy="18" r="2" fill="currentColor" />
                  <path d="M7 7C7 7 9 5 14 5C19 5 21 7 21 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
              </div>
              <div>
                <div className="wc-cookie-title">WeltasCorp Cookie</div>
                <div className="wc-cookie-subtitle">Gestión de consentimiento</div>
              </div>
            </div>

            <p className="wc-cookie-text">
              En NEON Music Cocktail usamos cookies técnicas para que la web, la carta digital y las reservas funcionen correctamente.
              Las cookies de <strong>analítica</strong> y <strong>marketing</strong> solo se activarán si nos das tu consentimiento.
              Puedes aceptar, rechazar las opcionales o configurar tus preferencias. Consulta la{" "}
              <Link to="/politica-cookies" className="wc-cookie-link">política de cookies</Link>{" "}
              y la <Link to="/privacidad" className="wc-cookie-link">política de privacidad</Link>.
            </p>

            <div className="wc-cookie-actions">
              <button className="wc-btn wc-btn-ghost" onClick={rejectAll}>
                Rechazar opcionales
              </button>
              <button className="wc-btn wc-btn-ghost" onClick={openSettings}>
                Personalizar
              </button>
              <button className="wc-btn wc-btn-primary" onClick={acceptAll}>
                Aceptar todas
              </button>
            </div>
          </div>
        </div>
      )}
      {showSettings && (
        <CookieSettings
          consent={consent}
          onClose={closeSettings}
          onAcceptAll={acceptAll}
          onRejectAll={rejectAll}
          onSave={saveCustom}
        />
      )}
    </>
  );
}
